import { render, staticRenderFns } from "./Spisat.vue?vue&type=template&id=98d587d8&scoped=true&"
import script from "./Spisat.vue?vue&type=script&lang=js&"
export * from "./Spisat.vue?vue&type=script&lang=js&"
import style0 from "./Spisat.vue?vue&type=style&index=0&id=98d587d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d587d8",
  null
  
)

export default component.exports